// src/components/orders/PickupCodeDialog.jsx
import React, { useState } from 'react';
import { X, CheckCircle } from 'lucide-react';

// 自提订单"完成"操作专用——客户到店报核销码，店员在这里核对输入，
// 核对通过才能真正完成订单（后端会二次校验，这里只是收集输入）
const PickupCodeDialog = ({ orderNo, submitting, onConfirm, onClose }) => {
  const [code, setCode] = useState('');

  const handleSubmit = () => {
    if (!code.trim()) { alert('请输入核销码'); return; }
    onConfirm(code.trim());
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl w-full max-w-sm">
        <div className="border-b p-6 flex justify-between items-center">
          <div>
            <h3 className="text-lg font-bold">自提核销</h3>
            <p className="text-sm text-gray-500 mt-0.5">{orderNo}</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 space-y-3">
          <label className="block text-sm font-medium text-gray-700">请客户报出核销码</label>
          <input
            type="text" value={code}
            onChange={e => setCode(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            placeholder="6位数字"
            maxLength={10}
            autoFocus
            className="w-full px-4 py-3 border rounded-lg text-center text-2xl font-bold tracking-widest focus:ring-2 focus:ring-blue-500"
          />
          <p className="text-xs text-gray-400">核销码在客户的订单详情页里，商品备好那一刻生成</p>
        </div>
        <div className="flex justify-end gap-3 p-6 border-t">
          <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
            取消
          </button>
          <button onClick={handleSubmit} disabled={submitting}
            className="flex items-center gap-1.5 px-5 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50">
            <CheckCircle className="w-4 h-4" />
            {submitting ? '核对中...' : '确认核销'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PickupCodeDialog;